import api, { urls } from 'app/API/httpClient';
import { omit } from 'lodash';

/**
 * @typedef {Object} RegistrationData
 *
 * @property {string} googleIdToken - Google JWT token
 * @property {string} email
 * @property {string} firstName
 * @property {string} lastName
 * @property {string} password
 * @property {string} source - for analytics
 * @property {string} fbclid - for analytics
 * @property {string} gclid - for analytics
 * @property {string} ga_client_id - for analytics
 * @property {string} token - google captcha token
 * @property {string} last_click_path - for analytics
 * @property {string} last_click - for analytics
 * @property {string} utm_source - for analytics
 * @property {string} utm_medium - for analytics
 * @property {string} utm_campaign - for analytics
 * @property {string} utm_content - for analytics
 * @property {string} utm_term - for analytics
 */

/**
 * @typedef {Object} RegistrationResponse
 *
 * @param {boolean} success
 * @param {number} errorCode
 * @param {string} errorMessage
 * @param {string} message
 * @param {string} link - sso link for easy login
 * @param {string} mobileLink - sso link for easy login to open mobile app
 * @param {string} temp
 * @param {any} altLink
 * */

/**
 * API handler for regular and google-sso sign-up flow
 *
 * @param {RegistrationData} data
 *
 * @returns Promise<AxiosResponse<RegistrationResponse>>
 */
function registration(data) {
  if (data.email) {
    return api.post(urls.register, omit(data, ['googleIdToken']));
  }

  if (data.googleIdToken) {
    return api.post(urls.googleSSO, omit(data, ['email', 'password']));
  }

  return Promise.resolve({
    data: {
      errorCode: 10,
      errorMessage: `Invalid data`,
      success: false,
      message: '',
      link: '',
      mobileLink: '',
      altLink: null,
    },
  });
}

export default registration;
